export default {
  functions: [
    {
      name: 'getPLPProducts',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'plpProducts',
      },
    },
  ],
};
